import { Resource } from '../../shared/resource';

export class Preferences extends Resource {
  organization?: string;
  profile?: string;
  name?: string;
  type?: string;
  blob?: any;
}
